export const Icon = ({...props}) => {
    return (
        <>
            <svg
                width={73}
                height={72}
                {...props}
            >
                <path
                    fill="#fff"
                    d="M31.31 62.997c0 2.07-1.68 3.75-3.75 3.75-2.067 0-3.765-1.68-3.765-3.75 0-2.07 1.665-3.75 3.735-3.75h.03c2.07 0 3.75 1.68 3.75 3.75Zm20.25-3.75h-.03a3.739 3.739 0 0 0-3.735 3.75c0 2.07 1.695 3.75 3.765 3.75 2.07 0 3.75-1.68 3.75-3.75 0-2.07-1.68-3.75-3.75-3.75Zm14.055-33.774-3.042 18.498c-.789 4.338-2.751 9.276-11.073 9.276H26.702c-4.077 0-7.59-3.045-8.166-7.083l-4.53-31.695a3.767 3.767 0 0 0-3.711-3.219H9.5a2.25 2.25 0 0 1 0-4.5h.798c4.077 0 7.59 3.045 8.166 7.083l.276 1.917H57.5a8.23 8.23 0 0 1 6.336 2.964 8.222 8.222 0 0 1 1.779 6.759Zm-5.238-3.879a3.743 3.743 0 0 0-2.88-1.347H19.38l3.612 25.281a3.768 3.768 0 0 0 3.711 3.219H51.5c4.791 0 5.958-1.788 6.639-5.541l3.042-18.501a3.76 3.76 0 0 0-.804-3.111Zm-16.539 7.311-6.411 6.408-2.41-2.409a2.25 2.25 0 0 0-3.182 3.183l3.999 3.999a2.246 2.246 0 0 0 3.18 0l8.001-8.001a2.25 2.25 0 0 0 0-3.183 2.243 2.243 0 0 0-3.177.003Z"
                />
            </svg>
        </>
    );
}